<div class="row my-2" *ngFor="let item of properties;">
    <div class="container d-flex" (click)="numberClickable()" [style.cursor]="isClickable ? 'pointer' : 'default'"
        style="cursor: pointer;">
        <div class="prgrss-title me-auto">{{item.name}}</div>
        <div class="prgrss-title my-lg-0">{{item.value}} of {{item.total}} <span
                *ngIf="item?.percent || item?.percent == 0">({{item.percent}}%)</span></div>
    </div>
    <div class="progress main-prgrss p-0">
        <div class="progress-bar" role="progressbar" [style.width.%]="item.width" [attr.aria-valuenow]="item.width"
            aria-valuemin="0" aria-valuemax="100">
        </div>
    </div>
</div>